export { default } from '../../../(drawer)/account/other-terms';
export * from '../../../(drawer)/account/other-terms';
